import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../reducers'
import * as actions from '../actions'
import { Filters } from '../services/assortment.service';
import { sendParentSubmitKreator } from '../parentCommunication';

function handleClick(filters: Filters, resetOrder: () => void, newOrder: boolean) {
    resetOrder();

    if (newOrder) {
        sendParentSubmitKreator({ 
            resetGutteringsCart: true, 
            filters: filters
        });
    } else {
        (window as any).submitKreator(JSON.stringify({ 
            resetGutteringsCart: true, 
            filters: filters
        }));
    }
}

const ResetBtn = ({ filters, iconsPath, newOrder, resetOrder }: ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <div onClick={ () => { handleClick(filters, resetOrder, newOrder) } } className="kr-ResetBtn">
            <img src={`${iconsPath}close.png`} alt="X" />
            <div>Zeruj zamówienie</div>
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    filters: state.filters,
    iconsPath: state.config.iconsPath,
    newOrder: state.config.newOrderApplication
})

const mapDispatchToProps = dispatch => ({
    resetOrder: () => {
        dispatch(actions.resetOrder())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetBtn)
